import { useState, useEffect } from 'react';
import Footer from '../../components/Footer/Footer';
import HeaderMain from '../../components/HeaderMain/HeaderMain';
import HeaderMobile from '../../components/HeaderMobile/HeaderMobile';
import bannerImage from '../../assets/bannerImage01.jpeg';
import styles from './CompanyInfo.module.scss';
import { useTranslation } from 'react-i18next';

function CompanyInfo() {
  const [selectedTab, setSelectedTab] = useState("comapnyInfo");
  const [isMobile, setIsMobile] = useState(false);
  const { t, i18n } = useTranslation();
  
  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage') || 'en';

    if (i18n.language !== savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
    
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [i18n]);
  
  return (
    <>
      {isMobile ? (
          <HeaderMobile />
        ) : (
        <HeaderMain 
          selectedTab={selectedTab}
          onTabChange={setSelectedTab}
        />  
        )}

      <div className={styles.contentWrap}>
        <img src={bannerImage} alt="image" />
        <div className={styles.textWrap}>
          <h3>{t('companyInfo.1')}</h3>
          <p>{t('companyInfo.2')}</p>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default CompanyInfo;
